import CryptoJS from 'crypto-js';

const CREDENTIALS_KEY = 'playbpo-creds';
const ENCRYPTION_KEY = 'playbpo-secure-key-2024';

export interface StoredCredentials {
  email: string;
  password: string;
}

export const authStorage = {
  saveCredentials(email: string, password: string) {
    try {
      const credentials: StoredCredentials = { email, password };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(credentials),
        ENCRYPTION_KEY
      ).toString();
      localStorage.setItem(CREDENTIALS_KEY, encrypted);
    } catch (error) {
      console.error('Error saving credentials:', error);
    }
  },

  getCredentials(): StoredCredentials | null {
    try {
      const encrypted = localStorage.getItem(CREDENTIALS_KEY);
      if (!encrypted) return null;

      const decrypted = CryptoJS.AES.decrypt(encrypted, ENCRYPTION_KEY);
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      if (!decryptedString) return null;

      return JSON.parse(decryptedString);
    } catch (error) {
      console.error('Error retrieving credentials:', error);
      return null;
    }
  },

  clearCredentials() {
    localStorage.removeItem(CREDENTIALS_KEY);
  },

  hasCredentials(): boolean {
    return !!localStorage.getItem(CREDENTIALS_KEY);
  }
};